var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    { ref: "dialog", attrs: { closable: "", title: "Edit stream" } },
    [
      _c("ui-input", {
        attrs: { label: "Stream title" },
        model: {
          value: _vm.streamTitle,
          callback: function ($$v) {
            _vm.streamTitle = $$v
          },
          expression: "streamTitle",
        },
      }),
      _vm._v(" "),
      _vm.streamURI !== null
        ? _c("ui-input", {
            attrs: {
              label: "RTMP URL",
              hint: "Concatenate server URL and stream key separated by a slash (/), to form a complete URL",
            },
            model: {
              value: _vm.streamURI,
              callback: function ($$v) {
                _vm.streamURI = $$v
              },
              expression: "streamURI",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ui-dialog-footer",
        [
          _c("ui-button", {
            attrs: {
              disabled: _vm.isFetching || _vm.streamTitle.length === 0,
              primary: "",
              text: "Update",
              tooltip: "Update stream with new title",
            },
            on: { click: _vm.updateStream },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }